module.exports = __webpack_public_path__ + "img/sudo-dark.e29ec8be.png";